import React, { useState } from 'react';
import { useAuth } from '../hooks/AuthProvider';
import OrganizationSelector from './OrganizationSelector';
import OrganizationDashboard from './OrganizationDashboard';
import LoadingPage from './LoadingPage';

const UserApp: React.FC = () => {
  const { currentUser, loading } = useAuth();
  const [selectedOrganization, setSelectedOrganization] = useState<string | null>(null);

  const handleSelectOrganization = (organizationId: string) => {
    setSelectedOrganization(organizationId);
  };

  const handleBackToOrganizations = () => {
    setSelectedOrganization(null);
  };

  if (loading) {
    return <LoadingPage />;
  }

  if (!currentUser) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Authentication Required</h2>
          <p className="text-gray-600 mb-6">Please log in to access your organizations.</p>
          <button 
            onClick={() => window.location.reload()}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded transition-colors"
          >
            Refresh Page
          </button>
        </div>
      </div>
    );
  }

  // Show organization dashboard if an organization is selected
  if (selectedOrganization) {
    return (
      <OrganizationDashboard
        organizationId={selectedOrganization}
        onBack={handleBackToOrganizations}
      />
    );
  }

  // Show organization selector
  return (
    <OrganizationSelector
      onSelectOrganization={handleSelectOrganization}
    />
  );
};

export default UserApp;